import { useEffect, useState } from "react";
import { api } from "../lib/api";

export default function Marquee() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    let alive = true;
    api.get("/case-studies?fields=client_name").then((r) => {
      if (alive) {
        const cases = (r.data?.case_studies || []).filter((c) => c.client_name);
        setItems(cases.map((c) => c.client_name));
      }
    }).catch(() => {});
    return () => { alive = false; };
  }, []);

  // Only render the marquee when we have real client names to show.
  if (items.length === 0) return null;

  // Duplicate for seamless scroll loop.
  const track = [...items, ...items];
  return (
    <div className="overflow-hidden border-y border-white/10 bg-black" data-testid="trusted-marquee">
      <div className="flex marquee-track gap-12 py-6 whitespace-nowrap">
        {track.map((name, i) => (
          <div
            key={i}
            className="font-display text-xl sm:text-2xl font-semibold text-white/40 hover:text-white transition-colors"
          >
            {name}
          </div>
        ))}
      </div>
    </div>
  );
}
